import { createContext } from "react";
import { viewerContext } from "../constants";
export var ViewerContext = createContext(viewerContext);
